import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { format } from 'date-fns'

import FieldLabelWrapper from '../../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../../components/Form/Field'

import { toPascalCase } from '../helpers'

import { selectedPartnershipSelector } from '../../../../../../../../modules/selectors/partnerships'

import { CONVENTION_NAME_DATE_FORMAT, CUSTOM_CAMPAIGN_NAME } from '../fields'

const CustomNameContent = ({ formik }) => {
  const { t } = useTranslation()

  const selectedPartnership = useSelector(selectedPartnershipSelector)

  const formattedCampaignNamePlaceholder = useMemo(() => {
    const { rights_holder_name: rightsHolderName, partner_name: partnerName } = selectedPartnership

    const nextDay = new Date()
    nextDay.setDate(nextDay.getDate() + 1)

    const formattedDate = format(nextDay, CONVENTION_NAME_DATE_FORMAT)

    // Campaign Name: e.g. {RightsHolderName}_{PartnerName}_Campaign_{Today + 1 in YYYYMMDD format}
    return `e.g. ${toPascalCase(rightsHolderName)}_${toPascalCase(partnerName)}_Campaign_${formattedDate}`
  }, [selectedPartnership])

  return (
    <>
      <p>{t('Enter a campaign name.')}</p>
      <FieldLabelWrapper label={t('Campaign Name')} labelFor={CUSTOM_CAMPAIGN_NAME}>
        <Field
          placeholder={formattedCampaignNamePlaceholder}
          disablePlaceholderFormatting={true}
          formik={formik}
          name={CUSTOM_CAMPAIGN_NAME}
        />
      </FieldLabelWrapper>
    </>
  )
}

export default CustomNameContent
